import React, { useEffect, useState } from 'react';
import { Table, Typography, Spin, Input, Select, Button, Row, Col, Space, Card } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getStockHistoryAll } from '../../../actions/report';
import { getAllBrand } from '../../../actions/Inventory/brandAction';
import { CheckCircleTwoTone, CloseCircleTwoTone, SearchOutlined, ClearOutlined } from '@ant-design/icons';

const { Title } = Typography;
const { Search } = Input;
const { Option } = Select;

const StockHistoryAllPage = () => {
  const [summaryData, setSummaryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    product_code: '',
    brand: '', // Add brand filter
    brand_name: '',
    is_balanced: null
  });
  const dispatch = useDispatch();
  
  // Get brand list from Redux store
  const brandList = useSelector(state => state.brand.brandlist);

  const fetchData = async (appliedFilters = {}) => {
    setLoading(true);
    const result = await dispatch(getStockHistoryAll(appliedFilters));
    if (result) {
      setSummaryData(result);
    }
    setLoading(false);
  };

  useEffect(() => {
    // Fetch brands on component mount
    dispatch(getAllBrand());
    fetchData();
  }, []);

  const handleSearch = () => {
    const appliedFilters = {};
    if (filters.product_code) appliedFilters.product_code = filters.product_code;
    if (filters.brand) appliedFilters.brand = filters.brand; // Add brand to applied filters
    if (filters.brand_name) appliedFilters.brand_name = filters.brand_name;
    if (filters.is_balanced !== null) appliedFilters.is_balanced = filters.is_balanced;
    
    fetchData(appliedFilters);
  };

  const handleClearFilters = () => {
    setFilters({
      product_code: '',
      brand: '', // Reset brand filter
      brand_name: '',
      is_balanced: null
    });
    fetchData();
  };

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const columns = [
    {
      title: 'SL',
      key: 'serial',
      align: 'center',
      render: (text, record, index) => index + 1,
    },
    { 
      title: 'Product Code', 
      dataIndex: 'title', 
      key: 'title',
      // sorter: (a, b) => a.title.localeCompare(b.title),
    },
    { 
      title: 'Total Product Entries', 
      dataIndex: 'total_entries', 
      key: 'total_entries',
      // sorter: (a, b) => a.total_entries - b.total_entries,
      align: 'center'
    },
    { 
      title: 'Stocks + Floating + Sold + Damage', 
      dataIndex: 'calculated_total', 
      key: 'calculated_total',
      // sorter: (a, b) => a.calculated_total - b.calculated_total,
      align: 'center'
    },
    {
      title: 'Balance Status',
      dataIndex: 'is_balanced',
      key: 'is_balanced',
      align: 'center',
      render: (is_balanced) =>
        is_balanced ? (
          <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: '20px' }} />
        ) : (
          <CloseCircleTwoTone twoToneColor="#ff4d4f" style={{ fontSize: '20px' }} />
        ),
      filters: [
        { text: 'Balanced', value: true },
        { text: 'Not Balanced', value: false },
      ],
      onFilter: (value, record) => record.is_balanced === value,
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Title level={3}>All Products Stock Summary</Title>
      
      <Card style={{ marginBottom: 16 }}>
        <Row gutter={[16, 16]}>
          <Col span="auto">
            <Search
              placeholder="Keyword Search by Product Name"
              value={filters.product_code}
              onChange={(e) => handleFilterChange('product_code', e.target.value)}
              onSearch={handleSearch}
              allowClear
            />
          </Col>
          
          <Col span="auto">
            <Select
              showSearch
              placeholder="Filter By Brand Name"
              value={filters.brand || undefined}
              onChange={(value) => handleFilterChange('brand', value)}
              style={{ width: '100%' }}
              allowClear
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {brandList && brandList.map((brand) => (
                <Option key={brand.id} value={brand.id}>
                  {brand.name}
                </Option>
              ))}
            </Select>
          </Col>
          
          {/* <Col xs={24} sm={12} md={6}>
            <Search
              placeholder="Search by Brand Name"
              value={filters.brand_name}
              onChange={(e) => handleFilterChange('brand_name', e.target.value)}
              onSearch={handleSearch}
              allowClear
            />
          </Col> */}
          
          <Col span="auto">
            <Select
              placeholder="Filter by Balance Status"
              value={filters.is_balanced}
              onChange={(value) => handleFilterChange('is_balanced', value)}
              style={{ width: '100%' }}
              allowClear
            >
              <Option value={true}>Balanced</Option>
              <Option value={false}>Not Balanced</Option>
            </Select>
          </Col>
          
          <Col span="auto">
            <Space>
              <Button 
                type="primary" 
                icon={<SearchOutlined />}
                onClick={handleSearch}
              >
                Apply Filters
              </Button>
              <Button 
                icon={<ClearOutlined />}
                onClick={handleClearFilters}
              >
                Clear Filters
              </Button>
            </Space>
          </Col>
        </Row>
      </Card>
      
      <Spin spinning={loading} size="large">
        <Table
          dataSource={summaryData}
          columns={columns}
          rowKey="title"
          pagination={{ 
            pageSize: 10,
            showSizeChanger: true,
            showTotal: (total) => `Total ${total} items`
          }}
          bordered
        />
      </Spin>
    </div>
  );
};

export default StockHistoryAllPage;